import React, { createContext, useContext } from 'react';
import { NotificationPreferences, useNotificationPreferences } from '../hooks/useNotificationPreferences';

interface NotificationContextType {
  preferences: NotificationPreferences | null;
  loading: boolean;
  updatePreference: (key: keyof NotificationPreferences, value: any) => Promise<void>;
}

const NotificationContext = createContext<NotificationContextType | null>(null);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { preferences, loading, updatePreference } = useNotificationPreferences();

  return (
    <NotificationContext.Provider value={{ preferences, loading, updatePreference }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within NotificationProvider');
  }
  return context;
};
